import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'utils/dayjs';
import { ISO_DATE } from 'utils/dates';

import session from 'containers/App/session';
import messages from './messages';
import { statsService } from 'utils/api';

import { FormattedMessage } from 'react-intl';
import { Form, Modal, message } from 'antd';
import { RangePicker } from 'components/DatePicker';
import Input from 'components/forms/Input';
import Button from 'components/forms/Button';
import Select from 'components/forms/Select';
import { NOTE_PRIORITY } from 'right-revenue-microservice-sdk/lib/constants';

const CreationUpdateModal = ({ open, values = {}, onClose }) => {
    if (!open) return null;
    const [dateRange, setDateRange] = useState({
        from: values.startDate,
        to: values.endDate,
    });
    const [fetching, setFetching] = useState(false);
    const [form] = Form.useForm();
    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const token = useSelector(session.selectors.selectUserToken);

    const onChangeDateRange = (dates) => {
        if (dates === null) {
            setDateRange({ from: undefined, to: undefined });
        } else {
            const [start, end] = dates;
            setDateRange({
                from: start && start.format(ISO_DATE),
                to: end && end.format(ISO_DATE),
            });
        }
    };
    const onSubmit = async () => {
        // Validate form
        form.validateFields()
            .then(async (formValues) => {
                setFetching(true);
                try {
                    await statsService({
                        token,
                        propertyId,
                    }).bulkAddNote({
                        start: dateRange.from,
                        end: dateRange.to,
                        note: formValues.note,
                        priority: formValues.priority,
                    });
                    onClose();
                    message.success('Note saved successfully');
                } catch (err) {
                    message.error('Error saving note(s)');
                }
                setFetching(false);
            })
            .catch(() => {});
    };

    return (
        <Modal
            maskClosable={false}
            closable={false}
            centered
            open
            title={<FormattedMessage {...messages.updateModalTitle} />}
            width={560}
            footer={[
                <Button disabled={fetching} key="cancelBtn" name="cancelBtn" onClick={onClose}>
                    <FormattedMessage {...messages.cancelBtn} />
                </Button>,
                <Button
                    key="updateBtn"
                    name="updateBtn"
                    type="primary"
                    loading={fetching}
                    disabled={fetching}
                    onClick={onSubmit}
                >
                    <FormattedMessage {...messages.applyBtn} />
                </Button>,
            ]}
            destroyOnClose
        >
            <Form
                form={form}
                layout="horizontal"
                initialValues={{ ...values }}
                labelAlign="left"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 18 }}
                colon={false}
                style={{
                    marginTop: '15px',
                }}
            >
                <div style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                    <FormattedMessage {...messages.updateModalDisclaimer} />
                </div>
                <Form.Item label={<FormattedMessage {...messages.dateRangeLabel} />}>
                    <RangePicker
                        inputReadOnly
                        bordered={false}
                        allowClear={false}
                        value={[dateRange.from && dayjs(dateRange.from), dateRange.to && dayjs(dateRange.to)]}
                        labelCol={{
                            span: 5,
                        }}
                        wrapperCol={{
                            span: 5,
                        }}
                        onChange={onChangeDateRange}
                        format="DD MMM YYYY"
                    />
                </Form.Item>
                <Form.Item label="Priority" key="priority" name="priority">
                    <Select style={{ width: 118 }} defaultValue="NONE">
                        <Select.Option key="NONE" value="">
                            NONE
                        </Select.Option>
                        {Object.keys(NOTE_PRIORITY).map((priority) => (
                            <Select.Option key={priority} value={NOTE_PRIORITY[priority]} />
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label={<FormattedMessage {...messages.noteLabel} />} name="note">
                    <Input.TextArea maxLength={200} rows={8} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreationUpdateModal;
